import React from 'react';
import { Link } from 'react-router-dom';
import {
  CartesianGrid,
  XAxis,
  YAxis,
  Legend,
  LineChart,
  Line,
  ResponsiveContainer
} from 'recharts';
import Button from 'jsx/elements/buttons/Button';
import useLocale from 'jsx/locale/useLocale';

export const NoAccess = () => {
  const { t } = useLocale();
  return (
    <div>
      <h2 className="text-gray-dark text-24">{t('noaccess_header')}</h2>
      <p>{t('noaccess_cta')}</p>

      <h1>Þú ert bara ekki með réttindi -sorry :P</h1>
      <p className="text-18 text-semibold text-center gutter-top">
        {t('noaccess_comparison_header')}
      </p>

      <div
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        className="gutter-bottom"
      >
        {/* <CountComparison /> */}
      </div>

      <div className="gutter-top">
        <h2 className="text-gray-dark text-24">{t('noaccess_newslist_header')}</h2>
        {/* Vantar gögn, tafla er tilbúin */}
      </div>
    </div>
  );
};
